<template>
    <div class="main_container">
        <div class="left_container"></div>
        <slot></slot>
    </div>
</template>

<style scoped>
    .main_container {
        display: flex;
        flex-direction: row;
    }
    .left_container {
        flex: 0 0 200px;
    }
</style>